import facebookIcon from '../../assets/icons/Facebook.png';
import instagramIcon from '../../assets/icons/Instagram.png';
import linkedInIcon from '../../assets/icons/LinkedIn.png';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './contact.scss';

const Contact = () => {
    const { hash } = useLocation();

    useEffect(() => {
        if (hash !== '#membership-inquiries') {
            return;
        }

        const scrollToMembership = () => {
            const membershipBlock = document.getElementById('membership-inquiries');
            const pageViewport = document.querySelector<HTMLElement>('.page-viewport');
            if (!membershipBlock || !pageViewport) {
                return;
            }

            const navigationOffset = 100;
            const targetPosition = membershipBlock.getBoundingClientRect().top
                - pageViewport.getBoundingClientRect().top
                + pageViewport.scrollTop
                - navigationOffset;
            pageViewport.scrollTo({ top: Math.max(0, targetPosition), behavior: 'smooth' });
        };

        const frame = window.requestAnimationFrame(() => {
            window.requestAnimationFrame(scrollToMembership);
        });

        return () => window.cancelAnimationFrame(frame);
    }, [hash]);

    return (
        <div className="contact-page">
            <section className="contact-hero">
                <div className="contact-hero__overlay" />
                <div className="contact-hero__content">
                    <h1>Contact</h1>
                    <p>Questions, comments, and membership inquiries</p>
                </div>
            </section>

            <section className="contact-details">
                <div className="contact-details__inner">
                    <div className="contact-details__section">
                        <div className="contact-details__content">
                            <div className="contact-details__info">
                            
                                <div className="contact-details__block">
                                    <p className="contact-details__role">Questions?</p>
                                    <p className="contact-details__intro">
                                        If you have any questions or comments, please call or email us at:
                                    </p>
                                    <a className="contact-details__phone" href="tel:+15736347144">
                                        (573) 634-7144
                                    </a>
                                    <a
                                        className="contact-details__email"
                                        href="mailto:info@msia-mo.org"
                                    >
                                        info@msia-mo.org
                                    </a>
                                    <p className="contact-details__followup">
                                        and we will get back with you as soon as possible.
                                    </p>
                                </div>
                                <div className="contact-details__block">
                                    <p className="contact-details__role">Address</p>
                                    <p>101 E. High St., First Floor</p>
                                    <p>Jefferson City, MO 65101</p>
                                </div>

                                <div className="contact-details__block">
                                    <p className="contact-details__role">Executive Director</p>
                                    <h3 className="contact-details__name">Shanon Hawk</h3>
                                    <a className="contact-details__email" href="mailto:shawk@atgovernmentstrategies.com">
                                        shawk@atgovernmentstrategies.com
                                    </a>
                                </div>

                                <div className="contact-details__block">
                                    <p className="contact-details__role">Deputy Executive Director</p>
                                    <h3 className="contact-details__name">Elizabeth Weber-Haynes</h3>
                                    <a
                                        className="contact-details__email"
                                        href="mailto:eweberhaynes@atgovernmentstrategies.com"
                                    >
                                        eweberhaynes@atgovernmentstrategies.com
                                    </a>
                                </div>

                                <div
                                    id="membership-inquiries"
                                    className={`contact-details__block contact-details__block--membership${hash === '#membership-inquiries' ? ' contact-details__block--highlighted' : ''}`}
                                >
                                    <p className="contact-details__role">Membership Inquiries</p>
                                    <p>To apply for membership, please reach out to our team at:</p>
                                    <a
                                        className="contact-details__email"
                                        href="mailto:info@msia-mo.org"
                                    >
                                        info@msia-mo.org
                                    </a>
                                </div>

                                <div className="contact-details__block contact-details__block--socials">
                                    <p className="contact-details__role">Social Media</p>
                                    <div className="contact-social-list">
                                        <a
                                            href="https://www.facebook.com/MSIA-Missouri-Self-Insurers-Association"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="contact-social-link"
                                        >
                                            <img src={facebookIcon} alt="Facebook" />
                                            <span>MSIA-Missouri Self-Insurers Association</span>
                                        </a>
                                        <a
                                            href="https://www.instagram.com/moselfinsurersassociation"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="contact-social-link"
                                        >
                                            <img src={instagramIcon} alt="Instagram" />
                                            <span>@moselfinsurersassociation</span>
                                        </a>
                                        <a
                                            href="https://www.linkedin.com/company/missouriselfinsurersassociation"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="contact-social-link"
                                        >
                                            <img src={linkedInIcon} alt="LinkedIn" />
                                            <span>Company/Missouriselfinsurersassociation</span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            {/* <form className="contact-form">
                                <label className="contact-form__field">
                                    <span>Name</span>
                                    <input type="text" name="name" />
                                </label>

                                <label className="contact-form__field">
                                    <span>Email</span>
                                    <input type="email" name="email" />
                                </label>

                                <label className="contact-form__field">
                                    <span>Subject</span>
                                    <input type="text" name="subject" />
                                </label>

                                <label className="contact-form__field">
                                    <span>Message</span>
                                    <textarea name="message" rows={6} />
                                </label>

                                <button type="submit" className="contact-form__submit">
                                    Send Message
                                </button>
                            </form> */}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;
